import { render, staticRenderFns } from "./EmailDetailsPopup.vue?vue&type=template&id=09683c4a&scoped=true"
import script from "./EmailDetailsPopup.vue?vue&type=script&lang=js"
export * from "./EmailDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09683c4a",
  null
  
)

export default component.exports